import React, { ChangeEvent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { ResizableInput } from 'shared/components/ui/resizable-input';

import * as Styled from './reminders-popup-menu.style';

export type ReminderOffsetInputRowProps = {
  hours: string;
  minutes: string;
  hasError?: boolean;
  onChangeHours: (value: string) => void;
  onChangeMinutes: (value: string) => void;
  onSubmit: () => void;
};

export const ReminderOffsetInputRow: React.FC<ReminderOffsetInputRowProps> = ({
  hours,
  minutes,
  hasError,
  onChangeHours,
  onChangeMinutes,
  onSubmit,
}) => {
  const { t } = useTranslation();

  const _onChangeHours = ({ target }: ChangeEvent<HTMLInputElement>) =>
    onChangeHours(target.value);

  const _onChangeMinutes = ({ target }: ChangeEvent<HTMLInputElement>) =>
    onChangeMinutes(target.value);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') {
      return;
    }

    e.preventDefault();
    onSubmit();
  };

  return (
    <Styled.InputRow>
      <ResizableInput
        inputMode="numeric"
        minWidth="2rem"
        placeholder={t('reminders.duration.hours-placeholder')}
        value={hours}
        onChange={_onChangeHours}
        onKeyDown={onKeyDown}
        showAsSmallFormInput
      />
      <Styled.InputText $isError={hasError}>
        {t('reminders.duration.hours-label')}
      </Styled.InputText>

      <ResizableInput
        inputMode="numeric"
        minWidth="2rem"
        placeholder={t('reminders.duration.minutes-placeholder')}
        value={minutes}
        onChange={_onChangeMinutes}
        onKeyDown={onKeyDown}
        showAsSmallFormInput
      />
      <Styled.InputText $isError={hasError}>
        {t('reminders.duration.minutes-label')}
      </Styled.InputText>
    </Styled.InputRow>
  );
};
